import { Card, CardContent, Grid, Typography } from '@mui/material'
import { Title } from 'components'
import { useLayout } from 'context'
import { getInvoicing } from 'controllers/invoicing/index'
import { InvoicingDto, VehicleEligibleForInvoicingDto, VehicleInvoicedDto, VehicleInvoicingServiceDto, VehicleReadyForInvoicingDto } from 'dtos/invoicing'
import { useEffect, useState } from 'react'
import InvoicedCard from './InvoicedCard'
import InvoicingServicesCard from './InvoicingServicesCard'
import ReadyForInvoicingCard from './ReadyForInvoicingCard'
import VehiclesEligibleForInvoicingCard from './VehiclesEligibleForInvoicingCard'

export default function Invoicing() {
  const { setIsLayoutLoading } = useLayout()

  const [vehiclesEligibleForInvoicing, setVehiclesEligibleForInvoicing] = useState<VehicleEligibleForInvoicingDto[]>([])
  const [invoicingServices, setInvoicingServices] = useState<VehicleInvoicingServiceDto[]>([])
  const [readyForInvoicing, setReadyForInvoicing] = useState<VehicleReadyForInvoicingDto[]>([])
  const [invoiced, setInvoiced] = useState<VehicleInvoicedDto[]>([])

  useEffect(() => {
    setIsLayoutLoading(true)

    getInvoicing()
      .then(res => refreshInvoicing(res.value))
      .finally(() => setIsLayoutLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const refreshInvoicing = (invoicing: InvoicingDto) => {
    if (invoicing.vehiclesEligibleForInvoicing) {
      setVehiclesEligibleForInvoicing(invoicing.vehiclesEligibleForInvoicing)
    }
    if (invoicing.invoicingServices) {
      setInvoicingServices(invoicing.invoicingServices)
    }
    if (invoicing.readyForInvoicing) {
      setReadyForInvoicing(invoicing.readyForInvoicing)
    }
    if (invoicing.invoiced) {
      setInvoiced(invoicing.invoiced)
    }
  }

  return (
    <>
      <Title>Invoicing</Title>

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography fontWeight='bold' variant='h5'>
                Invoicing
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <VehiclesEligibleForInvoicingCard refreshInvoicing={refreshInvoicing} vehiclesEligibleForInvoicing={vehiclesEligibleForInvoicing} />
        </Grid>

        <Grid item xs={12}>
          <InvoicingServicesCard invoicingServices={invoicingServices} refreshInvoicing={refreshInvoicing} />
        </Grid>

        <Grid item xs={12}>
          <ReadyForInvoicingCard readyForInvoicing={readyForInvoicing} refreshInvoicing={refreshInvoicing} />
        </Grid>

        <Grid item xs={12}>
          <InvoicedCard invoiced={invoiced} />
        </Grid>
      </Grid>
    </>
  )
}
